import React from 'react';
import PropTypes from 'prop-types';

var SubHeading = function SubHeading(_ref) {
    var text = _ref.text;

    return React.createElement(
        'h2',
        { className: 'mb-0' },
        text
    );
};

SubHeading.defaultProps = {

    text: "Sub Heading"
};

SubHeading.propTypes = process.env.NODE_ENV !== "production" ? {

    /**
     * Sub heading text
     */
    text: PropTypes.string

} : {};

export default SubHeading;